module.exports = __webpack_public_path__ + "img/trello_logo.98f686d9.png";